module.exports = __webpack_public_path__ + "img/fd_icon.5de3979d.gif";